import React from "react";
import "./Skills.css";
import Header from "../components/Header";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import LanguageCard from "../components/LanguageCard";

const data = {
  heading: "Skills and Certifications",
  image: "/images/education.svg",
  platforms: [
    {
      name: "Github",
      url: "https://github.com/paras-aghija",
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/paras-aghija-b9a8b817b/",
    },
    {
      name: "HackerRank",
      url: "https://www.hackerrank.com/paras_aghija",
    },
    {
      name: "Codeforces",
      url: "https://codeforces.com/profile/magneto_19",
    },
    {
      name: "CodeChef",
      url: "https://www.codechef.com/users/magneto_19",
    },
    {
      name: "Leetcode",
      url: "https://leetcode.com/magneto19/",
    },
  ],
  languages: [
    {
      name: "C++",
      points: 9,
    },
    {
      name: "Python",
      points: 7,
    },
    {
      name: "JavaScript",
      points: 8,
    },
    {
      name: "SQL",
      points: 8,
    },
    {
      name: "Solidity",
      points: 5,
    },
  ],
  tools: [
    "HTML",
    "CSS",
    "MongoDB",
    "MySQL",
    "Framer Motion",
    "Git",
    "GitHub",
    "Docker",
    "React",
    "React Native",
    "Node.js",
    "Express",
    "Bootstrap",
    "Tailwind",
    "ChakraUI",
    "GraphQL",
    "Netlify",
    "Heroku",
    "Linux",
    "Windows",
  ],
  certificates: [
    {
      platform: "Hackerrank",
      name: "Problem Solving",
      when: "July 2022",
      link: "https://www.hackerrank.com/certificates/dc7140614060",
    },
    {
      platform: "University of Helsinki MOOC",
      name: "Full Stack Web Development",
      when: "Jan 2022",
      link: "https://studies.cs.helsinki.fi/stats/api/certificate/fullstackopen/en/8693af3e126fcb145432b43bb3e3ed9b",
    },
    {
      platform: "University of Helsinki MOOC",
      name: "Devops with Docker",
      when: "Nov 2021",
      link: "https://studies.cs.helsinki.fi/stats/api/certificate/docker2021/en/80a2e8ee0ed7489085c0a85d0702cfde",
    },
    {
      platform: "High Technology Solutions",
      name: "Core Python",
      when: "May 2019",
    },
  ],
};

const Skills = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Header heading={data.heading} image={data.image} />
      <div className="skills-container">
        <div className="skills-wrapper">
          <div className="languages-wrapper">
            <h1 className="languages-heading">Languages</h1>
            <div className="languages-container">
              {data.languages.map((language) => (
                <LanguageCard
                  language={language.name}
                  points={language.points}
                />
              ))}
            </div>
          </div>
          <div className="tools-tech-wrapper">
            <h1 className="languages-heading">Tools and Technologies</h1>
            <div className="tools-container">
              {data.tools.map((tool) => (
                <div className="tool">{tool}</div>
              ))}
            </div>
          </div>
          <div className="certifications-wrapper">
            <h1 className="languages-heading">Certifications</h1>
            <div className="certifications-container">
              {data.certificates.map((certificate) => (
                <div className="certificate">
                  <h3 className="certificate-name">{certificate.name}</h3>
                  <div className="certificate-platform">
                    {certificate.platform}
                  </div>
                  <div className="certificate-when">{certificate.when}</div>
                  {certificate?.link && (
                    <div className="certificate-link">
                      <Link to={{ pathname: certificate.link }} target="_blank">
                        View Certificate
                      </Link>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="skill-links">
          {data.platforms.map((item) => (
            <Link to={{ pathname: item.url }} target="_blank">
              {item.name}
            </Link>
          ))}
        </div>
      </div>
      <Link to="/" className="home">
        Home
      </Link>
    </motion.div>
  );
};

export default Skills;
